/// <reference path="../_all.ts" />

module user {
  //https://material.angularjs.org/latest/Theming/03_configuring_a_theme

  //export function materialTheme($mdThemingProvider : angular.material.MDThemingProvider) {
  materialTheme.$inject = ['$mdThemingProvider'];
  export function materialTheme($mdThemingProvider: ng.material.IThemingProvider) {


    $mdThemingProvider.definePalette('photometer', {
      '50': 'f2f7f9',
      '100': 'd9e2e9',
      '200': 'a7b9c9',
      '300': '00aec3',
      '400': '6889a3',
      '500': '5b7e97',
      '600': '597796',
      '700': '3a658a',
      '800': '285480',
      '900': '004a76',
      'A100': 'b0bec5',
      'A200': '78909c',
      'A400': '546e7a',
      'A700': '263238',
      'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
      // on this palette should be dark or light

      'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
        '200', '300', '400', 'A100', 'A200'],
      'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });


    var whiteMap = $mdThemingProvider.extendPalette('grey', {
      '50': '#FFFFFF',
    });

    $mdThemingProvider.definePalette('white', whiteMap);


    $mdThemingProvider
      .theme('default')
      .primaryPalette('photometer', {
          'default': '900'
      })
      .accentPalette('photometer', {
          'default': 'A700'
      })  
      .backgroundPalette('white');
  }

}